<p-toast></p-toast>

<div class="grid">
  <div class="col-12">
    <rc-generic-button label="Add Compliance Action"
                       size="small"
                       [classes]="['mb-3']"
                       (click)="onShowComplianceActionDialog()"
                       [disabled]="isReadOnlyMode"></rc-generic-button>

    <p-table [value]="donationTransactions"
             dataKey="id"
             styleClass="rc-datatable-outlined first-col-border last-col-border"
             [expandedRowKeys]="expandedRows"
             [scrollable]="true"
             scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Split ID</th>
          <th>Donor</th>
          <th>Type</th>
          <th>Donation Date</th>
          <th>Amount</th>
          <th>Campaign</th>
          <th>Fund Code</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-donationTransactionItem>
        <tr>
          <td>{{ donationTransactionItem.splitId }}</td>
          <td>{{ donationTransactionItem.donorName }}</td>
          <td>{{ donationTransactionItem.type }}</td>
          <td>{{ donationTransactionItem.donationDate | date: 'MM/dd/yyyy' }}</td>
          <td>{{ calculateRemainingAmount(donationTransactionItem) | currency }}</td>
          <td>{{ donationTransactionItem.campaignName }}</td>
          <td>{{ donationTransactionItem.fundCode }}</td>
          <td>
            <rc-generic-button label="Edit"
                               iconImg="cog"
                               iconColor="teal-light"
                               [isIconOnly]="true"
                               [classes]="['table-action-btn']"
                               [disabled]="donationTransactionItem.type === 'Parent' || isReadOnlyMode"
                               (click)="openEditDonationDialog(donationTransactionItem)"></rc-generic-button>
            <rc-generic-button label="Delete"
                               *ngIf="donationTransactionItem.type !== 'Parent'"
                               iconImg="trash"
                               iconColor="red-light"
                               [isIconOnly]="true"
                               [classes]="['table-action-btn']"
                               (click)="confirmDelete(donationTransactionItem)"
                               [disabled]="isReadOnlyMode"></rc-generic-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="8" style="text-align: center;">
            There are no transactions for this donation.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- confirmation dialog -->
<p-confirmDialog 
  header="Confirm Action" 
  [acceptLabel]="'Confirm'" 
  [rejectLabel]="'Cancel'">
</p-confirmDialog>

<!-- Add Donation Compliance Action MODAL -->
<div id="compliance-action-card" data-cy="compliance-action-card">
  <p-toast />
  <p-dialog [(visible)]="showComplianceActionDialog"
            header="Add Donation Compliance Action"
            [modal]="true"
            [maximizable]="true"
            styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <form [formGroup]="complianceActionForm">
      <div class="mb-4">
        <h3 class="redwood-80">Original Donation Amount: <span class="font-normal">{{ originalDonationAmount | currency }}</span></h3>
      </div>

      <p-card styleClass="mb-3">
        <div class="formgrid grid">
          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="complianceType" class="field-label required">Compliance Type</label>
            <p-dropdown id="complianceType"
                        placeholder="Please Select"
                        formControlName="complianceType"
                        [options]="complianceTypeOptions">
            </p-dropdown>
            <div *ngIf="complianceActionForm.get('complianceType')?.touched && complianceActionForm.get('complianceType')?.invalid" class="block p-error">
              Compliance Type is required.
            </div>
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="fundCode" class="field-label required">Fund Code</label>
            <p-autoComplete id="fundCode"
                            placeholder="Type to Search"
                            formControlName="fundCode"
                            [suggestions]="filteredFundCodes"
                            (completeMethod)="searchFundCodes($event)"
                            (onSelect)="onFundCodeSelected($event)">
            </p-autoComplete>
            <div *ngIf="complianceActionForm.get('fundCode')?.touched && complianceActionForm.get('fundCode')?.invalid" class="block p-error">
              Please select a fund code.
            </div>
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="complianceActionAmount" class="field-label required">Amount</label>
            <input id="complianceActionAmount"
                   type="text"
                   pInputText
                   (input)="onAmountInput($event, 'complianceActionAmount')"
                   placeholder="$"
                   formControlName="complianceActionAmount" />
            <div *ngIf="complianceActionForm.get('complianceActionAmount')?.touched && complianceActionForm.get('complianceActionAmount')?.invalid" class="block p-error">
              Amount is required and must be greater than $0.01.
            </div>
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="complianceActionEditDate" class="field-label required">Edit Date</label>
            <p-calendar id="complianceActionEditDate"
                        [showIcon]="true"
                        [iconDisplay]="'input'"
                        placeholder="MM/DD/YYYY"
                        formControlName="complianceActionEditDate">
            </p-calendar>
            <div *ngIf="complianceActionForm.get('complianceActionEditDate')?.touched && complianceActionForm.get('complianceActionEditDate')?.invalid" class="block p-error">
              Edit Date is required.
            </div>
          </div>
        </div>
      </p-card>

      <p-card styleClass="mb-3" *ngIf="selectedComplianceType === '2' && !selectedDonor">
        <h4>Reattribution Donor</h4>
        <rc-generic-button label="Select Donor"
                           level="secondary"
                           size="small"
                           [classes]="['mb-3']"
                           (click)="openDonorSearchDialog()"
                           [disabled]="isReadOnlyMode">
        </rc-generic-button>
      </p-card>

      <p-card styleClass="mb-3" *ngIf="selectedDonor && selectedComplianceType === '2'">
        <h4>Reattribution Donor</h4>
        <div class="formgrid grid">
          <div class="col-12 mb-3 flex align-items-center gap-3">
            <strong>{{ selectedDonor.name }}</strong> ({{ selectedDonor.id }})
            <span>
              {{ selectedDonor.city }}
              <span *ngIf="selectedDonor.state">, </span>{{ selectedDonor.state }}
            </span>
            <p-button styleClass="p-button-icon-red-light mx-1"
                      icon="fa-sharp fa-light fa-circle-xmark"
                      title="Delete"
                      (onClick)="clearSelectedDonor()"
                      [disabled]="isReadOnlyMode">
            </p-button>
          </div>
          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="donorRelationship" class="field-label required">Donor Relationship</label>
            <p-dropdown id="donorRelationship"
                        placeholder="Please Select"
                        [options]="donorRelationships"
                        formControlName="donorRelationship"
                        optionLabel="text"
                        optionValue="value">
            </p-dropdown>
          </div>
        </div>
      </p-card>

      <!-- Donor Fund Totals Grid -->
      <p-card styleClass="pb-3" *ngIf="selectedRattributedDonorId">
        <h4>Fund Code History</h4>
        <app-donor-fund-totals-grid [donorId]="selectedRattributedDonorId">
        </app-donor-fund-totals-grid>
      </p-card>
    </form>

    <ng-template pTemplate="footer">
      <p-button label="Cancel"
                [text]="true"
                (onClick)="showComplianceActionDialog = false" />
      <p-button label="Save"
                [disabled]="complianceActionForm.invalid || isReadOnlyMode"
                (click)="onSubmitComplianceAction()">
      </p-button>
    </ng-template>
  </p-dialog>
</div>

<!-- Donor Search Modal -->
<p-dialog [(visible)]="showDonorSearchDialog"
          [modal]="true"
          header="Search for a Donor"
          styleClass="p-dialog-static p-dialog-full-width fadeinright animation-duration-300">

  <app-donor-search *ngIf="showDonorSearchDialog"
                    [showInDialog]="true"
                    (cancelEvent)="hideDonorSearchDialog()"
                    (selectEvent)="onDonorSelected($event)"
                    (closeDonorSearch)="hideDonorSearchDialog()">
  </app-donor-search>
</p-dialog>

<!-- Add Donor/Select Reattribution Donor MODAL -->
<div id="edit-donor-card" data-cy="edit-donor-card">
  <p-dialog [(visible)]="isDonorEditSidebarVisible"
            header="Edit Donor"
            [modal]="true"
            [maximizable]="true"
            styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <div>
      <div ngClass="medium loader-wrapper" *ngIf="isDonorEditDataLoading">
        <rc-loading-spinner></rc-loading-spinner>
      </div>

      <app-donor-add [isModalPopup]="true"
                     [donorToEdit]="donorToEdit"
                     [isEditMode]="true"
                     [activeStep]="editStep"
                     *ngIf="!isDonorEditDataLoading"
                     (closeEditModal)="closeModal()">
      </app-donor-add>
    </div>

  </p-dialog>
</div>

<p-dialog header="Confirm Action"
          [(visible)]="showDeleteConfirmDialog"
          [modal]="true"
          [closable]="false"
          styleClass="p-confirm-dialog">

  <p>Are you sure you want to delete this <b>{{ transactionToDelete?.type }}</b>?</p>

  <ng-template pTemplate="footer">
    <p-button label="Cancel"
              [outlined]="true"
              (onClick)="cancelDeleteTransaction()" />

    <p-button label="Delete"
              (onClick)="confirmDeleteTransaction()"
              data-cy="btn-Delete"
              [disabled]="isReadOnlyMode" />
  </ng-template>
</p-dialog>

<!-- Add Edit Donation Dialog -->
<p-dialog header="Edit Donation"
          [(visible)]="isEditDonationDialogVisible"
          [modal]="true"
          [maximizable]="false"
          draggable="false"
          styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">
  <form [formGroup]="editDonationForm">
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="fundCode" class="field-label required">Fund Code</label>
        <p-autoComplete id="fundCode"
                        placeholder="Type to Search"
                        formControlName="fundCode"
                        [suggestions]="filteredFundCodes"
                        (completeMethod)="searchFundCodes($event)"
                        (onSelect)="onEditDonationFundCodeSelected($event)">
        </p-autoComplete>
        <div *ngIf="editDonationForm.get('fundCode')?.touched && editDonationForm.get('fundCode')?.invalid" class="block p-error">
          Please select a fund code.
        </div>
      </div>
      <div class="field col-12">
        <label for="amount" class="field-label required">Amount</label>
        <input id="amount"
               type="text"
               (input)="onAmountInput($event, 'amount', 'editDonationForm')"
               pInputText
               formControlName="amount" />
      </div>
      <div class="field col-12" *ngIf="showRefundAmount">
        <label for="refundAmount" class="field-label required">Refund Amount</label>
        <input id="refundAmount"
               type="text"
               (input)="onAmountInput($event, 'refundAmount', 'editDonationForm')"
               pInputText
               formControlName="refundAmount" />
      </div>
      <div class="field col-12">
        <label for="editDate" class="field-label required">Edit Date</label>
        <p-calendar id="editDate" formControlName="editDate" dateFormat="mm/dd/yy" showIcon iconDisplay="input" placeholder="MM/DD/YYYY"></p-calendar>
      </div>
    </div>
    <div *ngIf="editDonationErrorMessage" class="block p-error mt-2">
      {{ editDonationErrorMessage }}
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" (click)="closeEditDonationDialog()" styleClass="p-button-text"></p-button>
    <p-button label="Save" severity="primary" (click)="saveEditedDonation()" [disabled]="editDonationForm.invalid || isReadOnlyMode"></p-button>
  </ng-template>
</p-dialog>
